/**
 * Created by MateuszWaligora on 14.07.2017.
 */
import Vue from 'vue';
import { utils } from '../../plugins/utils';
import { HTTPCODES } from '../../plugins/types';
import objectPath from 'object-path';
import axios from 'axios';

/**
 * @module Store/view
 * @description Module for products
 */

/**
 * @constant State of orders store
 * @type {object}
 * */
const state = {
    users: [],
    shops: [],
    userShops: [],
    userShopsIds: [],
    activeShop: '',
    userTree: {},
    eitherDisabledShops: false
};

/**
 * @constant Getters
 * @type {object}
 * */
const getters = {
    getUsers: state => state.users,
    getShops: state => {
        return state.shops;
    },
    getUserShops: state => state.userShops,
    getUserShopsData: state => state,
    getActiveShop: state => state.activeShop,
    getUserTree: state => state.userTree,
    getShopList: state => state.shops,
    getEitherDisabledShops: state => state.eitherDisabledShops
};

/**
 * @constant Mutations
 * @type {object}
 * */
const mutations = {
    addUser: (state, user) => state.users.push(user),
    setUsers: (state, users) => state.users = users,
    setUserTree: (state, userTree) => state.userTree = userTree,
    removeUser: (state, index) => state.users.splice(index, 1),
    addShop: (state, shop) => {
        state.shops.push(shop);
    },
    updateShop: (state, shop) => {
        let shopIndex = state.shops.findIndex(s => s.id === shop.id);
        if (shopIndex > -1) {
            let newShopList = [...state.shops];
            newShopList[shopIndex] = shop;
            state.shops = newShopList;
        }
    },
    setActiveShop: (state, shop) => state.activeShop = shop,
    setShops: (state, shops) => {
        state.shops = shops;
    },
    updateUserShopList: (state, shops) => {
        if (state.shops.length === 0) {
            state.userShops = shops;
        }
    },
    removeShop: (state, index) => state.shops.splice(index, 1),
    updateCompany: (state, form) => {
        state.users[state.users.findIndex(user => user.id === form.id)] = form;
    },
    setEitherDisabledShops: (state, toogle) => state.eitherDisabledShops = toogle
};

/**
 * @constant Actions
 * @type {object}

 * */
const actions = {
    async GetUserShopList ({ commit }, { id }) {
        try {
            let { data } = await Vue.axios.get(`/auth/user/${id}/shop`).catch(err => console.log(err));
            commit('updateUserShopList', data);
        } catch (err) {
            if (err.response && err.response.status >= 400) {
                commit('updateUserShopList', {});
            }
            throw new Error(err);
        }
    },
    async UpdateShop ({ commit, dispatch, getters }, { store, envs, setup }) {
        try {
            let { data } = await Vue.axios.post('/configurator/refresh', { store, envs, setup, setupid: setup.id });
            //let { data } = await axios.post('http://localhost:1337/refresh', { store, envs, setup, setupid: setup.id });
            dispatch('CurrentShop', data);
            return data;
        } catch (err) {
            console.error(err);
            commit('setShops', []);
            commit('addAlert', {
                title: 'Failed ',
                type: 'danger',
                body: 'to update shop'
            });
            throw new Error(err);
        }
    },
    async UpdateShopsEnvsBulk ({ commit, dispatch, getters }, { contexts, config, shop }) {
        try {
            let { data } = await Vue.axios.post('/configurator/refreshenvs', { contexts, config, shop });
            commit('addAlert', {
                title: 'Success ',
                type: 'success',
                body: 'to update envs for selected shops'
            });
            return data;
        } catch (err) {
            commit('addAlert', {
                title: 'Failed ',
                type: 'danger',
                body: 'to update envs for selected shops'
            });
            throw new Error(err);
        }
    },
    async SaveShop ({ commit, dispatch, getters }, { store, envs, setup, user }) {

        try {
            const users = await dispatch('GetAllUsers');
            const admin = users.find( user =>  (user.role.name === 'admin' && !user.parent));
            store.users.push({ id:admin.id });

            //let { data } = await axios.post('http://localhost:1337/init', { store, envs, setup });
            let { data } = await Vue.axios.post('/configurator/init', { store, envs, setup, user });

            dispatch('CurrentShop', data);

            return data;
        } catch (err) {
            console.error(err);
            commit('setShops', []);
            commit('addAlert', {
                title: 'Failed ',
                type: 'danger',
                body: 'to add shop'
            });
            throw new Error(err);
        }
    },
    async GetUser ({ commit }, id) {
        try {
            let { data: user } = await Vue.axios.get(`/auth/user/${id}/data/`);
            return user;
        } catch (err) {
            commit('addAlert', {
                title: 'Failed ',
                type: 'danger',
                body: `get user: ${id}`
            });
            throw new Error(err);
        }
    },
    async PutUser ({ dispatch, commit }, form) {/*Update user data*/
        try {
            let { data } = await Vue.axios.put(`/auth/user/${form.id}/data/`, form);
            commit('addAlert', {
                title: 'Successfully ',
                type: 'success',
                body: `updated a user ${form.id}`
            });
            return data;
        } catch (err) {
            commit('addAlert', {
                title: 'Failed ',
                type: 'danger',
                body: `update user: ${form.id}`
            });
            throw new Error(err);
        }
    },
    async DelUser ({ dispatch, commit }, { id, parent }) {/*Delete user data*/
        try {
            await dispatch('DelChildrenFromUser', { id: parent, children: { child: id } });
            let { data } = await Vue.axios.delete(`/auth/user/${id}/data`);
            commit('addAlert', {
                title: 'Successfully ',
                type: 'success',
                body: `deleted user: ${id}`
            });
            return data;
        } catch (err) {
            commit('addAlert', {
                title: 'Failed ',
                type: 'danger',
                body: `delete user: ${id}`
            });
            throw new Error(err);
        } finally {
            dispatch('GetAllUsers');
        }
    },
    async DelAllUser ({ dispatch, commit }) {/*Delete all user data*/
        try {
            let { data } = await Vue.axios.delete('/auth/user/data');
            commit('addAlert', {
                title: 'Successfully ',
                type: 'success',
                body: 'deleted all users'
            });
            return data;
        } catch (err) {
            commit('addAlert', {
                title: 'Failed ',
                type: 'danger',
                body: 'delete all users'
            });
            throw new Error(err);
        } finally {
            dispatch('GetAllUsers');
        }
    },
    async GetAllUsers ({ commit }) {/**/
        try {
            let { data } = await Vue.axios.get('/auth/user/data');
            let userMap = utils.getNestedKeyPaths(data, 'id');
            data.forEach((user, index, theArray) => {
                if (user.parent) {
                    let parentIndex = userMap.resultArray
                        .findIndex(({ searchedKey }) => searchedKey === user.parent);
                    if (parentIndex > -1) {
                        let path = userMap.resultArray[parentIndex].path.slice(0, -1);
                        let parent = objectPath.get(theArray, path);
                        if (parent) {
                            if (!parent.dependents) {
                                parent.dependents = [{ ...user }];
                            } else {
                                parent.dependents.push({ ...user });
                            }
                            theArray[index] = null;
                        }
                    }
                    userMap = utils.getNestedKeyPaths(theArray, 'id');
                }
            });
            const users = data.filter(user => user);
            commit('setUsers', users);
            return users;
        } catch (err) {
            commit('setUsers', []);
            commit('addAlert', {
                title: 'Failed ',
                type: 'danger',
                body: 'to get user list'
            });
            throw new Error(err);
        }
    },
    async RegisterUser ({ rootState, dispatch, commit }, form) {/*Add new user to database*/
        try {
            let { data } = await Vue.axios.post('/auth/registration', form);
            try {
                let { data: childData } = await dispatch('AddChildrenToUser', {
                    id: form.parentId || rootState.auth.user.id,
                    children: { child: data.id }
                });
                commit('addAlert', {
                    title: 'Successfully ',
                    type: 'success',
                    body: 'registered a user'
                });
                return { childData, data };
            } catch (err) {
                commit('addAlert', {
                    title: 'Failed ',
                    type: 'danger',
                    body: 'add child account to your user account'
                });
            } finally {
                dispatch('GetAllUsers');
            }
            return data;
        } catch (err) {
            commit('addAlert', {
                title: 'Failed ',
                type: 'danger',
                body: 'register user'
            });
            throw new Error(err);
        } finally {
            dispatch('GetAllUsers');
        }
    },
    //eslint-disable-next-line
    async AddChildrenToUser({ commit }, { id, children }) {/*Add new user to database*/
        try {
            let { data } = await Vue.axios.post(`/auth/user/${id}/child`, children);
            commit('addAlert', {
                title: 'Successfully ',
                type: 'success',
                body: `added a child user to ${id}`
            });
            return data;
        } catch (err) {
            throw new Error(err);
        }
    },
    //eslint-disable-next-line
    async GetChildrenFromUser({ dispatch }, id) {/*Add new user to database*/
        try {
            let { data } = await Vue.axios.get(`/auth/user/${id}/child`);
            let children = [];
            await data.forEach(async id => await dispatch('GetUser', id).then(child => children.push(child.role.name)));
            return children;
        } catch (err) {
            throw new Error(err);
        }
    },
    async GetChildrenDataFromUser ({ dispatch }, id) {
        try {
            let { data } = await Vue.axios.get(`/auth/user/${id}/child`);
            let children = [];
            await data.forEach(async id => await dispatch('GetUser', id)
                .then(child => child.role.name === 'key_account' ? children.push(child) : null));
            return children;
        } catch (err) {
            throw new Error(err);
        }
    },
    async DelChildrenFromUser ({ commit }, { id, children }) {/*Add new user to database*/
        try {
            let { data } = await Vue.axios.delete(`/auth/user/${id}/child`, { data: children });
            commit('addAlert', {
                title: 'Successfully ',
                type: 'success',
                body: `detached a child user: from user ${id}`
            });
            return data;
        } catch (err) {
            throw new Error(err);
        }
    },

    async AddShopToUser ({ commit, dispatch, getters }, { users, user, shop }) {/*Add correlation between user and shop (Add to shop set)*/
        try {
            let { data } = await Vue.axios.post(`/auth/user/${user.id}/shop`, {
                shop: shop.id
            })
            if(user.id !== shop.users[0].id) {
                await Vue.axios.post(`/auth/user/${shop.users[0].id}/shop`, {
                    shop: shop.id
                })
            }
            if(user.role !== 'admin') {
                const users = await dispatch('GetAllUsers');
                const admin = users.filter(u => u.role.name === 'admin');
                await Vue.axios.post(`/auth/user/${admin[0].id}/shop`, {
                    shop: shop.id
                })
            }

            return { data };
        } catch (err) {
            if (err.response && err.response.status >= 400) {
                if (err.response.status === 401) {
                    commit('addAlert', {
                        title: 'Unauthorized ',
                        type: 'danger',
                        body: ''
                    });
                    return { err: HTTPCODES[err.response.status] };
                }
            }
            commit('addAlert', {
                title: 'Failed ',
                type: 'danger',
                body: 'get shop for given user'
            });
            throw new Error(err);
        }
    },
    async GetShopFromUser ({ }, { id }) {/*Get all user children*/
        try {
            let { data } = await Vue.axios.get(`/auth/user/${id}/shop`);
            return { data };
        } catch (err) {
            if (err.response && err.response.status >= 400) {
                return { data: [] };
            }
            console.log(err);
        }
    },
    /*Delete correlation between user and shop (delete from shop set)*/
    async DelShopFromUser ({ commit, dispatch }, { id, shopId }) {
        try {
            let { data } = await Vue.axios.delete(`/auth/user/${id}/shop/${shopId}`);
            try {
                await dispatch('deleteUserFromShop', { shopId: shopId, userId: id });
                commit('addAlert', {
                    title: 'Successfully ',
                    type: 'success',
                    body: `detached a shop ${shopId} from user ${id}`
                });
                return { data };
            } catch (err) {
                if (err.response && err.response.status >= 400) {
                    if (err.response.status === 401) {
                        commit('addAlert', {
                            title: 'Unauthorized ',
                            type: 'danger',
                            body: ''
                        });
                        return { err: HTTPCODES[err.response.status] };
                    }
                }
                commit('addAlert', {
                    title: 'Failed ',
                    type: 'danger',
                    body: ''
                });
                throw new Error(err);
            }
        } catch (err) {
            if (err.response && err.response.status >= 400) {
                if (err.response.status === 401) {
                    commit('addAlert', {
                        title: 'Unauthorized ',
                        type: 'danger',
                        body: ''
                    });
                    return { err: HTTPCODES[err.response.status] };
                }
            }
            commit('addAlert', {
                title: 'Failed ',
                type: 'danger',
                body: 'remove shop from given user'
            });
            throw new Error(err);
        }
    },

    async GetAllShops ({ commit, dispatch, rootState }, id = rootState.auth.user.id) {/**/
        try {
            const url = rootState.auth.user.role === 'admin' && id === rootState.auth.user.id ?
                `/stores/store` : `/stores/store/user/${id}`;

            const allShops = rootState.registration.eitherDisabledShops ? '?all=true' : ""
            try {
                let {data} = await Vue.axios.get(`${url}${allShops}`)
                commit('setShops', data);
                return { shopsData: data };

            } catch (error) {
                commit('setShops', []);
                return { shopsData: [] };
            }
        } catch (err) {
            console.error(err);
            commit('setShops', []);
            commit('addAlert', {
                title: 'Failed ',
                type: 'danger',
                body: 'to get shop list'
            });
            throw new Error(err);
        }
    },
    async GetShopsAll ({ commit, dispatch, rootState }, { id = rootState.auth.user.id, eitherDisabledShops = true}) {/**/
        try {
            const url = rootState.auth.user.role === 'admin' && id === rootState.auth.user.id ?
              `/stores/store?all=true` : `/stores/store/user/${id}`;

            const { data } = await Vue.axios.get(url);
            return data.filter(shop => eitherDisabledShops ? true : shop.enabled )

        } catch (error) {
            commit('addAlert', {
                title: 'Failed ',
                type: 'danger',
                body: 'to get shop list'
            });
            return [];
        }
    },
    async GetShopById ({ commit }, id) {/**/
        try {
            let {data} = await Vue.axios.get(`/stores/store/${id}`);
            try {
                let {data: {results: [shop] }} = await Vue.axios.get('/collecter/classes/symbols', {
                    params: { where: { context: id, symbol: 'shop_icon' }},
                    headers: {'X-Parse-Application-Id': 'uGJEQnHj5DajteynrhvzAXnMH8'}
                });
                if(shop && shop.link){
                    data.iconURL = shop.link;
                }

            } catch (error) {
                // commit('addAlert', {
                //     title: 'Failed ',
                //     type: 'danger',
                //     body: 'to get data about symbols'
                // });
            }
            return data;
        } catch (err) {
            if (err.response && err.response.status >= 400) {
                return { err: HTTPCODES[err.response.status] };
            }
            commit('addAlert', {
                title: 'Failed ',
                type: 'danger',
                body: 'to get shop by id'
            });
            throw new Error(err);
        }
    },

    async addShopAsync ({ commit, dispatch, getters }, store) {/**/
        try {
            let { data } = await Vue.axios.post('/stores/store/', store);
            dispatch('GetAllShops');
            commit('addAlert', {
                title: 'Successfully ',
                type: 'success',
                body: 'added a shop'
            });

            return { data };
        } catch (err) {
            console.error(err);
            commit('setShops', []);
            commit('addAlert', {
                title: 'Failed ',
                type: 'danger',
                body: 'to add shop'
            });
            throw new Error(err);
        }
    },
    async updateShopAsync ({ commit, dispatch, getters }, shop) {/**/
        try {
            await Vue.axios.put(`/stores/store/${shop.id}`, shop);
            dispatch('GetAllShops');
            commit('addAlert', {
                title: 'Successfully ',
                type: 'success',
                body: `updated shop ${shop.id}`
            });

            return { data: shop.id };
        } catch (err) {
            if (err.response && err.response.status >= 400) {
                if (err.response.status === 401) {
                    commit('addAlert', {
                        title: 'Unauthorized ',
                        type: 'danger',
                        body: 'to update shop'
                    });
                    return { err: HTTPCODES[err.response.status] };
                }
            }
            commit('setShops', []);
            commit('addAlert', {
                title: 'Failed ',
                type: 'danger',
                body: `to update shop ${shop.id}`
            });
            throw new Error(err);
        }
    },

    async addUserToShop ({ commit }, { shopId, userIds }) {/**/
        try {
            let { data } = await Vue.axios({ method: 'PUT', url: `/stores/store/${shopId}/user`, data: userIds, headers: { Store: userIds } });
            commit('addAlert', {
                title: 'Successfully ',
                type: 'success',
                body: 'added a user to shop'
            });
            return data;
        } catch (err) {
            if (err.response && err.response.status >= 400) {
                if (err.response.status === 401) {
                    commit('addAlert', {
                        title: 'Unauthorized ',
                        type: 'danger',
                        body: 'add user to shop'
                    });
                    return { err: HTTPCODES[err.response.status] };
                }
            }
            commit('setShops', []);
            commit('addAlert', {
                title: 'Failed ',
                type: 'danger',
                body: 'to add shop'
            });
            throw new Error(err);
        }
    },

    async deleteUserFromShop ({ commit, dispatch }, { shopId, userId }) {/**/
        try {
            let { data } = await Vue.axios.delete(`/stores/store/${shopId}/user/${userId}`);
            dispatch('GetAllShops');
            commit('addAlert', {
                title: 'Successfully ',
                type: 'success',
                body: 'removed a user from shop'
            });
            return data;
        } catch (err) {
            if (err.response && err.response.status >= 400) {
                if (err.response.status === 401) {
                    commit('addAlert', {
                        title: 'Unauthorized ',
                        type: 'danger',
                        body: 'add user to shop'
                    });
                    return { err: HTTPCODES[err.response.status] };
                }
            }
            commit('setShops', []);
            commit('addAlert', {
                title: 'Failed ',
                type: 'danger',
                body: 'to add shop'
            });
            throw new Error(err);
        }
    },

    async DelShop ({ dispatch, commit }, shop) {/*Delete user data*/
        try {
            let { data } = await Vue.axios.delete(`/stores/store/${shop.id}`);
            commit('addAlert', {
                title: 'Successfully ',
                type: 'success',
                body: `removed shop ${shop.id}`
            });

            return data;
        } catch (err) {
            commit('addAlert', {
                title: 'Failed ',
                type: 'danger',
                body: `delete shop: ${shop.id}`
            });
            throw new Error(err);
        } finally {
            dispatch('GetAllShops');
        }
    },

    SetActiveShopAction ({ commit }, shop) {/*Delete user data*/
        commit('setActiveShop', shop);
        if (utils.isNil(shop)) {
            window.localStorage.removeItem('Store');
            return;
        }
        if (shop.length) {
            window.localStorage.setItem('Store', shop);
        } else {
            window.localStorage.setItem('Store', shop.id);
        }
    },
    async buildDependentsTree ({ dispatch }, user) {
        return new Promise((resolve) => {
            if (!user.child || user.child.length === 0) {
                resolve(user);
            }
            user.dependents = [];
            user.child.forEach(async (child) => {
                try {
                    let newChild = await dispatch('GetUser', child);
                    if (newChild && newChild.child) {
                        let dependent = await dispatch('buildDependentsTree', newChild);
                        user.dependents.push(dependent);
                    }
                } catch (err) {
                    console.log(err);
                }
            });
            resolve(user);
        });

    }
};

export default {
    state,
    getters,
    mutations,
    actions
};
